export default {
  getOrdinance: "/ordinance/getOrdinance",
};
